<div class="container">
  <h1>Searchable Fields</h1>

  @if (isLoading) {
    <div class="loading-spinner">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }

  @if (!isLoading && dictionaries.length>1) {
    <div class="filter-container">
      <mat-form-field appearance="outline">
        <mat-label>Filter by Dictionary</mat-label>
        <mat-select [value]="selectedDictionaryId" (selectionChange)="filterByDictionary($event.value)">
          <mat-option [value]="null" i18n="@@dictionary.allSelected">All Dictionaries</mat-option>
          @for (dict of dictionaries; track dict) {
            <mat-option [value]="dict.id">
              {{ dict.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }

  <table mat-table [dataSource]="dataSource" matSort [hidden]="isLoading" class="mat-elevation-z8">
    <!-- Field Column -->
    <ng-container matColumnDef="label">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Field</th>
      <td mat-cell *matCellDef="let row">{{ row.label }}</td>
    </ng-container>

    <!-- Level Column -->
    <ng-container matColumnDef="level">
      <th mat-header-cell *matHeaderCellDef>Level</th>
      <td mat-cell *matCellDef="let row">{{ row.level }}</td>
    </ng-container>

    <!-- Dictionary Column -->
    <ng-container matColumnDef="dictionaryName">
      <th mat-header-cell *matHeaderCellDef>Dictionary</th>
      <td mat-cell *matCellDef="let row">
        @for (dict of row.dictionaries; track dict) {
          <div>
            {{ dict.name }}
          </div>
        }
      </td>
    </ng-container>

    <!-- Searchable Column -->
    <ng-container matColumnDef="searchable">
      <th mat-header-cell *matHeaderCellDef>Searchable</th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          [checked]="row.searchable"
          (change)="toggleSearchable(row)"
        ></mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  @if (!isLoading) {
    <div class="button-container">
      <button mat-raised-button (click)="applyChanges()" color="primary">
        <mat-icon>save</mat-icon>
        <span class="icon-text">Apply</span>
      </button>
    </div>
  }
</div>
